module.exports = __webpack_public_path__ + "img/1559.f85dab50.gif";